import { httpClient } from '@shared/api'
import type { PaginatedList } from '@shared/api/types'
import type { RelationDTO } from '../model/types'
import { mapCreateRelationArgsToDTO, mapEditRelationArgsToDTO, mapRelationFromDTO } from './mappers'
import type { CreateRelationArgs, DeleteRelationArgs, EditRelationArgs, GetRelationsArgs } from './types'

export const getRelations = async ({ page, pageSize, role }: GetRelationsArgs) => {
    const {
        data: { results, next, previous, count }
    } = await httpClient.get<PaginatedList<RelationDTO>>(`/ads/relations`, {
        params: {
            page,
            page_size: pageSize,
            role
        }
    })

    return {
        count,
        next,
        previous,
        results: results.map(mapRelationFromDTO)
    }
}

export const createRelation = async (data: CreateRelationArgs) => {
    const { data: result } = await httpClient.post<RelationDTO>('/ads/relations', mapCreateRelationArgsToDTO(data))
    return mapRelationFromDTO(result)
}

export const updateRelation = async ({ id, ...data }: EditRelationArgs) => {
    const { data: result } = await httpClient.put<RelationDTO>(`/ads/relations/${id}`, mapEditRelationArgsToDTO(data))
    return mapRelationFromDTO(result)
}

export const deleteRelation = async ({ id }: DeleteRelationArgs) => {
    await httpClient.delete<void>(`/ads/relations/${id}`)
}
